export default {
  dialogImage: '',
  dialog: 0,
}
